import { portalApi } from '@/util/apiClient'
import { queryClient } from '@/util/queryClient'
import { useQuery } from '@tanstack/vue-query'
import type { MaybeRefOrGetter } from 'vue'

export const APPLIANCES_QUERY_KEY = ['galvanickAppliances', 'sidebarWarning']

/**
 * The network sensor register, fetched whole. The sidebar's deployment warning
 * and the dashboard's sensor tile share this one query so they never disagree.
 */
const useGalvanickAppliances = (
  options: { enabled?: MaybeRefOrGetter<boolean>; refetchInterval?: number } = {},
) =>
  useQuery(
    {
      queryKey: APPLIANCES_QUERY_KEY,
      queryFn: () => portalApi.galvanickAppliancesGet({ query: { limit: 100 } }),
      staleTime: 60_000,
      ...options,
    },
    queryClient,
  )

export default useGalvanickAppliances
